<template>
    <span v-if="error">
        <span v-tooltip="error" class="label label--rejected" v-if="status.toLowerCase() === 'rejected'">Rejected</span>
        <span v-tooltip="error" class="label label--expired" v-if="status.toLowerCase() === 'expired'">Expired</span>
        <span v-tooltip="error" class="label label--paid" v-if="status.toLowerCase() === 'processed'">Processed</span>
        <span v-tooltip="error" class="label label--processing" v-if="status.toLowerCase() === 'in queue'">In Queue</span>
        <span v-tooltip="error" class="label label--paid" v-if="status.toLowerCase() === 'processed'">Processed</span>
        <span v-tooltip="error" class="label label--paid" v-if="status.toLowerCase() === 'paid'">Paid</span>
        <span v-tooltip="error" class="label label--created" v-if="status.toLowerCase() === 'created'">Created</span>
        <span v-tooltip="error" class="label label--accepted" v-if="status.toLowerCase() === 'accepted'">Accepted</span>
        <span v-tooltip="error" class="label label--invalid" v-if="status.toLowerCase() === 'invalid'">Invalid</span>
        <span v-tooltip="error" class="label label--canceled" v-if="status.toLowerCase() === 'canceled'">Canceled</span>
        <span v-tooltip="error" class="label" v-if="status.toLowerCase() === 'sent'">Sent</span>
    </span>
    <span v-else >
        <span class="label label--rejected" v-if="status.toLowerCase() === 'rejected'">Rejected</span>
        <span class="label label--expired" v-if="status.toLowerCase() === 'expired'">Expired</span>
        <span class="label label--paid" v-if="status.toLowerCase() === 'processed'">Processed</span>
        <span class="label label--processing" v-if="status.toLowerCase() === 'in queue'">In Queue</span>
        <span class="label label--paid" v-if="status.toLowerCase() === 'processed'">Processed</span>
        <span class="label label--paid" v-if="status.toLowerCase() === 'paid'">Paid</span>
        <span class="label label--created" v-if="status.toLowerCase() === 'created'">Created</span>
        <span class="label label--accepted" v-if="status.toLowerCase() === 'accepted'">Accepted</span>
        <span class="label label--invalid" v-if="status.toLowerCase() === 'invalid'">Invalid</span>
        <span class="label label--canceled" v-if="status.toLowerCase() === 'canceled'">Canceled</span>
        <span class="label" v-if="status.toLowerCase() === 'sent'">Sent</span>
    </span>
</template>

<script>

  export default {
    name: 'Label',
    props: ['status','error'],
    data () {
      return {
        tooltipError:""
      }
    },
  }
</script>
